<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<nav aria-label="Main navigation">
  <fuse-vertical-navigation
    #navComponent
    class="dark bg-gray-900 print:hidden z-[99999]"
    [appearance]="navigationAppearance"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- Logo -->
      <div class="flex items-center justify-center h-20">
        <img
          class="w-8"
          src="assets/images/logo/eprint-logo.svg"
          alt="ePrint company logo">
        </div>
      </ng-container>
    </fuse-vertical-navigation>
  </nav>

  <!-- Wrapper -->
  <div class="flex flex-col flex-auto w-full min-w-0 max-h-[100%] overflow-auto" id="container">

    <!-- Header -->
    <header class="overflow-auto relative flex flex-0 items-center w-full h-12 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden"  aria-label="Page header">
      <div class="flex items-center pr-2 space-x-2">
        <!-- Navigation toggle button -->
        <button
          class="focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          mat-icon-button id="denseCmp_toggleNavBtn"
          aria-label="Toggle navigation menu"
          (click)="toggleNavigation('mainNavigation')">
          <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>
        <!-- Navigation appearance toggle button -->
        @if (hideToggleButton) {
          <button
            class="hidden md:inline-flex focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
            aria-label="Toggle navigation appearance"
            mat-icon-button id="denseCmp_toggleAppearanceBtn"
            (click)="toggleNavigationAppearance()">
            <mat-icon [svgIcon]="'heroicons_outline:switch-horizontal'"></mat-icon>
          </button>
        }
      </div>

      <app-breadcrumb [breadCrumbConfig]="breadCrumbConfig"></app-breadcrumb>

      <!-- <app-breadcrumb></app-breadcrumb> -->
      <!-- Components -->
      <!-- <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
      <app-languages></app-languages>
      <user></user>
    </div> -->
  </header>

  <!-- Content -->
  <div class="flex flex-col flex-auto" aria-label="Main content">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
    Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>

  <!-- Footer -->
  <footer class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden" aria-label="Page footer">
    <span class="font-medium text-secondary">ePRINTit &copy; {{currentYear}}</span>
  </footer>

</div>
